import AddUserToWeeklyEmail from '@/services/users/preferencesService/AddUserToWeeklyEmail';
import UpdateUserToLilyFree from '@/services/users/preferencesService/UpdateUserToLilyFree';

export default class PreferencesService {
    async addUserToWeeklyEmail(userId) {
        return (new AddUserToWeeklyEmail()).handle(userId);
    }

    async updateUserToLilyFree(userId) {
        return (new UpdateUserToLilyFree()).handle(userId);
    }
}
